module.exports = __webpack_public_path__ + "static/img/logo-menu2.3a01bc00.png";